import type { QueryOptions } from '@apollo/client';
import gql from 'graphql-tag';

import gqlClient from 'src/gql/candidateClient';

export const GET_JOB_DETAILS = gql`
  query getJobDetails($jobId: ID!) {
    jobDetails(id: $jobId) {
      job {
        id
        title
        createdAt {
          dateTimeUtc
        }
        isExpired
      }
    }
  }
`;

const getJobDetails = (jobAdId: string) => {
  const queryGql = async (options: QueryOptions) =>
    (await gqlClient(window)).query({
      fetchPolicy: 'cache-first',
      ...options,
    });

  return queryGql({
    query: GET_JOB_DETAILS,
    variables: {
      jobId: jobAdId,
    },
  });
};
export default getJobDetails;
